import * as React from 'react'

import { Box, Chevron, Touchable } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import { observer } from 'mobx-react'

import { CardHeader } from 'modules/core/components/OldCard'
import { next, previous } from 'modules/core/lib/frequencies'

import type FaceRecognitionLogsForm from 'modules/employees/components/FaceRecognition/Logs/Layout/form'
import { DEFAULT_PERIOD_TYPE } from 'modules/employees/components/FaceRecognition/Logs/Layout/form'

interface NavigatorProps {
  logsForm: FaceRecognitionLogsForm
  enablePrevious: boolean
  enableNext: boolean
  onPrevPeriod: () => void
  onNextPeriod: () => void
}

const Navigator = ({
  logsForm,
  enablePrevious,
  enableNext,
  onPrevPeriod,
  onNextPeriod,
}: NavigatorProps) => {
  return (
    <Box alignItems="center" flexDirection="row" gap="s16">
      {enablePrevious && (
        <Touchable onClick={onPrevPeriod}>
          <Chevron type="secondary" direction="left" />
        </Touchable>
      )}
      <Box>{logsForm.date.format('MMMM Y')}</Box>
      {enableNext && (
        <Touchable onClick={onNextPeriod}>
          <Chevron type="secondary" direction="right" />
        </Touchable>
      )}
    </Box>
  )
}

interface NavigationHeaderProps {
  logsForm: FaceRecognitionLogsForm
  minDate: moment.Moment
  maxDate: moment.Moment
}

const NavigationHeader = ({ logsForm, minDate, maxDate }: NavigationHeaderProps) => {
  const previousDate = previous(logsForm.date, DEFAULT_PERIOD_TYPE)
  const nextDate = next(logsForm.date, DEFAULT_PERIOD_TYPE)
  const enablePrevious = !minDate || previousDate.isAfter(minDate)
  const enableNext = !maxDate || nextDate.isBefore(maxDate)

  const onPrevPeriod = () => {
    return logsForm.changePeriod(previousDate)
  }

  const onNextPeriod = () => {
    return logsForm.changePeriod(nextDate)
  }

  return (
    <CardHeader
      middle={
        <Navigator
          logsForm={logsForm}
          enablePrevious={enablePrevious}
          enableNext={enableNext}
          onPrevPeriod={onPrevPeriod}
          onNextPeriod={onNextPeriod}
        />
      }
    />
  )
}

export default observer(NavigationHeader)
